import { useMutation } from '@tanstack/react-query';

import { getRappelConseiller } from '@/services/getRappelConseiller/getRappelConseillerService';
import { log } from '@/utils/functions/logger/logger';

export const useRappelConseiller = () => {
  return useMutation({
    mutationFn: getRappelConseiller,
    onError: (error) => {
      log.error(`useRappelConseiller failed: ${error}`);
    },
  });
};
